import { useState } from 'react'

import { Box } from '@mui/material'
import Header from './Header'
import Footer from './Footer'
import OurStory from '../components/OurStory'
import TeamMember from '../components/TeamMember'
import OurJourney from '../components/OurJourney'
import HeroSection from '../components/HeroSection'
import VisionMission from '../components/VisionMission'
import CurrentStatus from '../components/CurrentStatus'
import GallerySection from '../components/GallerySection'
import ServiceCountry from '../components/ServiceCountry'

const Home = () => {
    const [language, setLanguage] = useState('EN'); // Default to English

    return (
        <Box sx={{ backgroundColor: '#fafafa' }}>
            <Header language={language} onLanguageChange={setLanguage} />
            <Box component="main">
                <Box id="home">
                    <HeroSection language={language} />
                </Box>
                <Box id="story">
                    <OurStory language={language} />
                </Box>
                <Box id="vision">
                    <VisionMission language={language} />
                </Box>
                <Box id="team">
                    <TeamMember language={language} />
                </Box>
                <Box id="timeline">
                    <OurJourney language={language} />
                </Box>
                <Box id="gallery">
                    <GallerySection language={language} />
                </Box>
                <Box id="whyus">
                    <CurrentStatus language={language} />
                </Box>
                <Box id="coverage">
                    <ServiceCountry language={language} />
                </Box>
            </Box>
            <Footer language={language} />
        </Box>
    )
}

export default Home